import React, { useState, useEffect, useCallback } from 'react';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';
//import { useNavigate } from "react-router-dom";
import PayNow from "./PayNow";

interface Bill {
    id: string;
    feeType: string;
    amount: string;
}

interface Invoice {
    id: string;
    invoiceNo: string;
    date: string;
    paymentMode: string;
    bills: Bill[];
}

const Finance: React.FC = () => {
    const [data, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showPaymentHistory, setShowPaymentHistory] = useState(false);
    const [payments, setPayments] = useState<Invoice[]>([]);

    const [showPayNow, setShowPayNow] = useState(false);
    const [fees, setFees] = useState<any[]>([]);
    const [loadingPay, setLoadingPay] = useState(false);
    const [loadingHistory, setLoadingHistory] = useState(false);
    const [paymentResult, setPaymentResult] = useState<any>(null);
    const [showResult, setShowResult] = useState(false);
    const [entryScreen, setEntryScreen] = useState<"PAYNOW" | "HISTORY" | "FINANCE">("FINANCE");

    const fetchFinance = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await serviceApi.get<any>(
                environment.finance
            );
            if (response.status === 'SUCCESS') {
                setData(response.objectData);
            }
        } catch (error) {
            console.error("Finance fetch error:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const fetchPayments = async () => {
        try {
            setLoadingHistory(true);
            const res: any = await serviceApi.get(environment.invoices);
            setPayments(res?.dataList || []);
        } catch (err) {
            console.error("Payment history API error:", err);
        } finally {
            setLoadingHistory(false);
        }
    };

    useEffect(() => {
        const restore = () => {
            const saved = sessionStorage.getItem("paymentResult");

            if (saved) {
                const parsed = JSON.parse(saved);
                setPaymentResult(parsed);
                setShowResult(true);
            }
        };
        restore();
        window.addEventListener("focus", restore);
        return () => {
            window.removeEventListener("focus", restore);
        };
    }, []);

    const launchEasebuzz = (response: any) => {
        const data =
            typeof response === "string"
                ? JSON.parse(response)
                : response;

        if (!data?.objectData?.access_key) {
            console.error("Missing access_key");
            return;
        }
        if (!(window as any).EasebuzzCheckout) {
            alert("Easebuzz SDK not loaded");
            return;
        }
        const easebuzzCheckout = new (window as any).EasebuzzCheckout(
            data.objectData.key,
            "prod"
        );

        let isHandled = false;
        easebuzzCheckout.initiatePayment({
            access_key: data.objectData.access_key,
            onResponse: (response: any) => {
                if (isHandled) return;
                isHandled = true;
                const raw =
                    response?.status ||
                    response?.txnStatus ||
                    response?.error ||
                    "";
                const status = String(raw).toLowerCase();
                const isCancel =
                    status.includes("cancel") ||
                    response?.error === "user_cancelled";
                const isFailed =
                    status.includes("fail") || isCancel;
                const result = {
                    status: isFailed ? "FAILED" : "SUCCESS",
                    transactionId:
                        response?.easepayid ||
                        response?.txnid ||
                        "N/A",
                    amount: response?.amount || 0,
                    date: new Date().toISOString(),
                };
                setPaymentResult(result);
                setShowResult(true);
                sessionStorage.setItem(
                    "paymentResult",
                    JSON.stringify(result)
                );
            },

            theme: "#123456",
        });
    };



    const initiatePayment = async (finalFees: any[]) => {
        try {
            setLoadingPay(true); // 👈 SHOW SPINNER IMMEDIATELY

            const total = finalFees.reduce(
                (sum, item) => sum + Number(item.amount || 0),
                0
            );

            const feeTypes: any = {};
            finalFees.forEach((item) => {
                if (item.amount > 0) {
                    feeTypes[item.feeTitle] = item.amount;
                }
            });

            const payload = {
                amount: total,
                feeTypes,
                paymentMode: "UPI",
            };

            const response = await serviceApi.put(
                environment.onlinePayementRequest,
                payload
            );

            launchEasebuzz(response);

        } catch (err) {
            console.error(err);
        } finally {
            setLoadingPay(false);
        }
    };
    useEffect(() => {
        fetchFinance();
    }, [fetchFinance]);

    if (!data && !isLoading) return null;
    if (showPaymentHistory) {
        return (
            <div className="notification-page">
                {loadingHistory && (
                    <div className="loading-overlay">
                        <div className="loading-overlay__content">
                            <div className="spinner spinner--lg"></div>
                            <span className="loading-text">Loading payment history...</span>
                        </div>
                    </div>
                )}
                <div
                    className="content-header"
                    style={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "35px 12px 15px 12px",
                        minHeight: "40px"
                    }}
                >
                    <button
                        onClick={() => setShowPaymentHistory(false)}
                        style={{
                            position: "absolute",
                            left: "12px",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "var(--colorPrimaryDark)",
                            padding: 0,
                            margin: 0
                        }}
                    >
                        ← Back
                    </button>
                    <h2
                        className="title-text notification-heading"
                        style={{
                            margin: 0,
                            fontSize: "20px",
                            textAlign: "center"
                        }}
                    >
                        Payment History
                    </h2>
                </div>

                {payments.map((item) => (
                    <div
                        key={item.id}
                        className="event-container"
                        style={{ marginBottom: "var(--sz-16)" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span
                                className="event-date"
                                style={{
                                    color: "var(--colorAccentDark)",
                                    fontWeight: 700,
                                    fontStyle: "italic",
                                    fontSize: "var(--sz-14)",
                                }}
                            >
                                {item.date}
                            </span>

                            <span
                                className="nav-item"
                                style={{
                                    fontSize: "var(--sz-12)",
                                    fontWeight: "bold",
                                }}
                            >
                                #{item.invoiceNo}
                            </span>
                        </div>

                        <div
                            className="horizontal-divider"
                            style={{
                                margin: "var(--sz-6) 0 var(--sz-10) 0",
                            }}
                        />

                        <div className="event-item" style={{ padding: 0 }}>
                            {item.bills?.map((bill, index) => (
                                <React.Fragment key={bill.id}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        <div>
                                            <p
                                                style={{
                                                    margin: 0,
                                                    fontWeight: 600,
                                                    color: "var(--colorAccentDark)",
                                                }}
                                            >
                                                {bill.feeType}
                                            </p>

                                            <p
                                                style={{
                                                    margin: 0,
                                                    color: "#16a34a",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Paid: ₹{bill.amount}
                                            </p>
                                        </div>

                                        <div
                                            style={{
                                                fontSize: "var(--sz-12)",
                                                color: "var(--colorAccentDark)",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {item.paymentMode}
                                        </div>
                                    </div>

                                    {index !== item.bills.length - 1 && (
                                        <div
                                            className="horizontal-divider"
                                            style={{
                                                margin: "6px 0 10px 0",
                                                opacity: 0.6,
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            <div style={{ padding: "12px 12px 0 12px" }}>
                <h2 className="title-text notification-heading" style={{ margin: 0 }}>
                    Finance
                </h2>
            </div>
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading finance...</span>
                    </div>
                </div>
            )}

            {loadingPay && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Processing payment...</span>
                    </div>
                </div>
            )}
            {showPayNow ? (
                <div className="paynow-page" style={{ padding: "15px" }}>
                    <button
                        onClick={() => setShowPayNow(false)}
                        style={{
                            marginBottom: "15px",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "var(--colorPrimaryDark)"
                        }}
                    >
                        ← Back
                    </button>

                    <PayNow
                        fees={fees}
                        onProceed={(finalFees) => initiatePayment(finalFees)}
                    />
                </div>
            ) : (
                <div className="finance-container" style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
                    <div className="finance-header" style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', marginBottom: '5px' }}>
                            <span style={{ color: 'red', fontWeight: 'bold' }}>Total Fee:</span>
                            <span>₹{data?.amount}</span>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'red', fontWeight: 'bold' }}>Paid:</span>
                                <span>₹{data?.paid}</span>
                            </div>

                            <div style={{ display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'red', fontWeight: 'bold' }}>Due:</span>
                                <span>₹{data?.due}</span>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '15px',
                        padding: '20px 10px',
                        backgroundImage: 'linear-gradient(to bottom, #f9f9f9, #fff)'
                    }}>
                        <button
                            onClick={() => {
                                fetchPayments();
                                setEntryScreen("HISTORY");
                                setShowPaymentHistory(true);
                            }}
                            style={{
                                backgroundColor: '#4a6572',
                                color: 'white',
                                border: 'none',
                                padding: '8px 20px',
                                borderRadius: '20px',
                                fontWeight: '600',
                                fontSize: '14px'
                            }}>
                            Payment History
                        </button>

                        <button
                            onClick={() => {
                                const dueFees = (data?.fees || [])
                                    .filter((x: any) => Number(x.due) > 0)
                                    .map((x: any) => ({
                                        feeTitle: x.feeTitle,
                                        due: Number(x.due),
                                        amount: Number(x.due),
                                    }));

                                setFees(dueFees);
                                setEntryScreen("PAYNOW");
                                setShowPayNow(true);
                            }}
                            style={{
                                backgroundColor: '#4a6572',
                                color: 'white',
                                border: 'none',
                                padding: '8px 20px',
                                borderRadius: '20px',
                                fontWeight: '600',
                                fontSize: '14px'
                            }}
                        >
                            Pay Now
                        </button>
                    </div>

                    <div className="fee-list" style={{ padding: '0 15px' }}>
                        {data?.fees?.map((item: any, index: number) => (
                            <div key={index} style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                    <span style={{ color: '#d9534f', fontWeight: 'bold', fontSize: '15px', textTransform: 'uppercase' }}>
                                        {item.feeTitle}
                                    </span>

                                    <div style={{ textAlign: 'right' }}>
                                        <span style={{ color: '#28a745', fontWeight: 'bold', fontSize: '13px' }}>Paid: </span>
                                        <span style={{ fontSize: '13px' }}>₹{item.paid}</span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>₹{item.amount}</span>

                                    <div style={{ textAlign: 'right' }}>
                                        <span style={{ color: '#d9534f', fontWeight: 'bold', fontSize: '13px' }}>Due: </span>
                                        <span style={{ fontSize: '13px' }}>₹{item.due}</span>
                                    </div>
                                </div>

                                <div style={{
                                    borderBottom: '1px dashed #999',
                                    marginTop: '12px',
                                    width: '100%'
                                }} />
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {showResult && paymentResult && (
                <div className="modal-backdrop-custom" style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
                    <div className="receipt-card" style={{ width: "90%", maxWidth: "320px", background: "#fff", borderRadius: "16px", padding: "20px", textAlign: "center", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }}>
                        <div style={{ fontSize: "50px", marginBottom: "10px" }}>
                            {paymentResult.status === "SUCCESS" ? <span style={{ color: "green" }}>✔</span> : <span style={{ color: "red" }}>✖</span>}
                        </div>
                        <h3 style={{ marginBottom: "15px" }}>{paymentResult.status}</h3>
                        <div style={{ textAlign: "left", fontSize: "14px" }}>
                            <p><b>Transaction ID:</b> {paymentResult.transactionId}</p>
                            <p><b>Amount:</b> ₹{paymentResult.amount}</p>
                            <p><b>Date:</b> {new Date(paymentResult.date).toLocaleString()}</p>
                        </div>
                        <button
                            style={{ marginTop: "15px", width: "100%", padding: "10px", borderRadius: "10px", background: "#4a6572", color: "#fff", border: "none", fontWeight: "bold" }}
                            onClick={() => {
                                setShowResult(false);
                                setPaymentResult(null);
                                sessionStorage.removeItem("paymentResult");
                                setShowPayNow(false);
                                setShowPaymentHistory(false);
                                setEntryScreen("FINANCE");
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Finance;